import { useState } from 'react';

const NOTIFICATIONS_SEEN_KEY = 'hm-notifications-seen';

export const useSeenNotifications: () => [boolean, () => void] = () => {
    const [isSeen, setIsSeen] = useState(() => {
        return typeof window !== 'undefined'
            ? window?.localStorage.getItem(NOTIFICATIONS_SEEN_KEY) !== null
            : false;
    });

    const setSeenIndicator = () => {
        const seenDate = new Date().toISOString();
        window.localStorage.setItem(NOTIFICATIONS_SEEN_KEY, seenDate);
        setIsSeen(true);
    };

    return [isSeen, setSeenIndicator];
};
